module.exports = __webpack_public_path__ + "img/a2_spec.fffa8e99.png";